module.exports = __webpack_public_path__ + "img/doorLogo37.9b46669a.png";